<template>
    <div>
        <div class="txd__fields">
            <div class="txd__field">
                <span class="txd__label">{{ $t('frontend_analytics_transactions_affiliate') }}</span>
                <span class="txd__value" :class="{ 'txd__value--empty': !hasValue(selectedTransaction.affiliate_name) }">
                    {{ hasValue(selectedTransaction.affiliate_name) ? selectedTransaction.rendered_affiliate_name : '—' }}
                    <button v-if="selectedTransaction.status == 'captured'" type="button" class="txd__edit"
                        :title="$t('frontend_analytics_transactions_affiliate')" @click="openChangeAffiliateModal">
                        <pencil-icon />
                    </button>
                </span>
            </div>
            <div class="txd__field">
                <span class="txd__label">{{ $t('frontend_analytics_transactions_affiliate_email') }}</span>
                <span v-if="hasValue(selectedTransaction.affiliate_email)" class="txd__value">{{ selectedTransaction.rendered_affiliate_email }}</span>
                <span v-else class="txd__value txd__value--empty">—</span>
            </div>

            <div class="txd__field">
                <span class="txd__label">{{ $t('frontend_analytics_transactions_username') }}</span>
                <span v-if="hasValue(selectedTransaction.affiliate_username)" class="txd__value">{{ selectedTransaction.rendered_affiliate_username }}</span>
                <span v-else class="txd__value txd__value--empty">—</span>
            </div>
            <div class="txd__field">
                <span class="txd__label">{{ $t('frontend_analytics_transactions_commision') }}</span>
                <span class="txd__value" :class="{ 'txd__value--empty': !hasValue(selectedTransaction.human_readable_commission) }">
                    {{ hasValue(selectedTransaction.human_readable_commission) ? selectedTransaction.human_readable_commission : '—' }}
                    <button v-if="hasValue(selectedTransaction.affiliate_username) &&
                        selectedTransaction.status == 'captured'" type="button" class="txd__edit"
                        :title="$t('frontend_analytics_transactions_commision')" @click="openChangeCommissionModal">
                        <pencil-icon />
                    </button>
                </span>
            </div>

            <div class="txd__field">
                <span class="txd__label">{{ $t('frontend_analytics_transactions_commision_type') }}</span>
                <span v-if="hasValue(selectedTransaction.commission_type)" class="txd__value">{{ selectedTransaction.commission_type }}</span>
                <span v-else class="txd__value txd__value--empty">—</span>
            </div>

            <div v-if="selectedTransaction.assisted_affiliate_id" class="txd__field">
                <span class="txd__label">Assisted Affiliate</span>
                <span class="txd__value">{{ selectedTransaction.assisted_affiliate_name }}</span>
            </div>
            <div v-if="selectedTransaction.assisted_affiliate_id" class="txd__field">
                <span class="txd__label">{{ $t('frontend_groovesell_transaction_assis_aff_comm') }}</span>
                <span class="txd__value">{{ selectedTransaction.assisted_affiliate_commission }}</span>
            </div>
        </div>

        <div v-if="selectedTransaction.suspected_affiliate_fraud == 1" class="txd__callout">
            <span>
                <strong>{{ $t('frontend_analytics_transactions_note') }}</strong>
                {{ $t('frontend_analytics_transactions_note_text') }}
            </span>
        </div>
    </div>
</template>
<script>
import PencilIcon from '@/assets/images/icons/PencilIcon.svg';

export default {
    components: {
        PencilIcon,
    },
    props: {
        selectedTransaction: {
            type: Object,
            default: () => { },
        },
    },
    methods: {
        hasValue(value) {
            return !!value && String(value).trim() != '';
        },
        openChangeAffiliateModal() {
            this.$root.$emit('modal-open', 'change-transaction-affiliate-modal');
        },
        openChangeCommissionModal() {
            this.$root.$emit('modal-open', 'change-affiliate-commission-modal');
        },
    }

}
</script>
